<script setup>
const route = useRoute();
const slug = route.params.slug;
const config = useRuntimeConfig();
const baseURL = config.public.baseUrl;

const { data, error } = await useFetch(
  `${baseURL}/content/services/desktop/${slug}-content.json`
);

if (error.value || !data.value) {
  throw createError({
    statusCode: 404,
    statusMessage: "Page not found",
  });
}
const header = data.value?.header;
const expertise = data.value?.expertise;
const google_autocomplete = data.value?.google_autocomplete;
const service_content = data.value?.service_content;
const contact_us_carousel = data.value?.contact_us_carousel;
const why_choose_us = data.value?.why_choose_us;
const our_promises = data.value?.our_promises;
const metaTags = data.value?.meta_tags;

useHead({
  title: metaTags?.title || "",
  meta: metaTags?.meta || [],
  link: [
    { rel: "preload", as: "image", href: header.image }
  ]
});

const visible = ref(false);

const openModal = () => {
  visible.value = true;
};

</script>

<template>
  <!-- Hero Banner -->
  <WrHeroBanner :data="data.header" @open-modal="openModal" />

  <section class="section-spacing dark:bg-none relative z-10">
    <div class="container-wrapper-xl">
      <FloatingList :heading="data?.google_autocomplete?.heading" :subheading="data?.google_autocomplete?.subheading"
        :expertisetext="data?.expertise?.expertisetext" :textcontent="data?.expertise?.textcontent"
        :text="data?.google_autocomplete?.text" :keywords="data?.google_autocomplete?.keywords" />
      <GoogleRating />
    </div>
  </section>

  <section class="section-spacing bg-[#5F4CA4] dark:bg-none">
    <div class="container-wrapper-xl">
      <WrContactUsCarouselSection :data="contact_us_carousel" />
    </div>
  </section>

  <section class="section-spacing dark:bg-none relative z-10">
    <div class="container-wrapper-lg">
      <WrExpertiseSection :expertise="expertise" />
    </div>
  </section>

  <section class="section-spacing dark:bg-none mt-16 relative z-10">
    <div class="container-wrapper-xl">
      <WrWhoAreWeCard :heading="service_content.heading" :subheading="service_content.subheading"
        :content="service_content.text" />
    </div>
  </section>
  <!--Section Let’s start together Starts-->

  <section class="section-spacing dark:bg-none relative z-10">
    <div class="container-wrapper-xl">
      <WrImageContent header="Let’s start together"  src="/images/why-chose-us.webp" height="360"
        width="466" :whyChooseUs="why_choose_us" @open-modal="openModal" />
    </div>
  </section>

  <!--Section Let’s start together Ends-->
  <section class="section-spacing dark:bg-none relative z-10">
    <div class="container-wrapper-xl">
       <div class="flex items-start justify-between w-full max-lg:flex-col">
        <div class="w-full h-full lg:max-w-[35%]">
          <NuxtImg
            src="/images/what-we-can-do.webp"
            height="463"
            width="428"
            loading="lazy"
            format="webp"
            alt="What We Can Do"
          />
        </div>
        <div class="flex flex-col items-start w-full lg:max-w-[50%]">
          <h3 class="xl:text-[44px] text-[31px] mt-5 font-bold relative">
            {{ our_promises.main_heading }}
          </h3>
        
          <p class="text-lg mt-5">
            {{ our_promises.sub_text }}
          </p>
          <ul class="flex lg:flex-wrap lg:flex-row flex-col w-full lg:items-center items-start gap-y-3 mt-6">
            <li v-for="item in why_choose_us.cardcontent"
              class="bg-[url('/images/right-single.webp')] bg-no-repeat bg-[position:0_8px] m-0 pl-[22px] w-[50%] text-sm">
              {{ item.heading }}
            </li>
          </ul>
        </div>
      </div>
    </div>
  </section>

  <!-- Our Capabilities  Starts-->
  <WrOurServiceSection />
  <!-- Our Capabilities Ends -->

  <section class="section-spacing dark:bg-none relative z-10 overflow-visible order-9">
    <div class="container-wrapper-lg w-full relative">
     <div class="hidden  dark:block opacity-30  md:size-[764px] rounded-full 
         bg-[linear-gradient(136.28deg,_rgba(51,4,79,0)_30.43%,_#260049_54.53%,_#36006F_92.37%)] 
         absolute -top-[30%] -left-[67%]">
      </div>

      <div class="hidden  dark:block opacity-50 size-[190px] rounded-full 
         bg-[image:var(--bg-circle-top-light)] 
         absolute -bottom-[15%] right-0 top-0">
      </div>
      <WrSelectedProject />
    </div>
  </section>

  <section class="relative section-spacing dark:bg-none overflow-hidden z-20">
    <div class="container-wrapper-xl">
      <h2 class="text-center mb-11">
        <WrGradientText text="Trusted for excellence and efficiency" />
        <p class="text-lg text-[var(--foreground)] font-anvtgrade-book">
          Webreinvent is trusted by leading organisations to enhance their
          development and operational efficiency.
        </p>
      </h2>
      <!-- Carousel Section -->
      <WrTestimonialCardCarousel />
      <WrButton link="/testimonials" container-class="max-w-max mx-auto mt-7">View All</WrButton>
    </div>
  </section>
  <WrContactFormPopup v-if="visible" :isOpen="visible" @close="visible = false" class="z-30" />
</template>
